import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import { TbRobot } from 'react-icons/tb';
import { MdOutlineHourglassEmpty } from 'react-icons/md';

const RED = '#C03626';

const AICEInternal = () => {
  const [hoveredActive, setHoveredActive] = useState(false);

  return (
    <div style={pageStyle}>
      <SeoHead
        title="AICE Intern | AICE platform"
        description="Intern side for AICE medarbejdere."
        canonicalPath="/aice"
        robots="noindex,nofollow"
      />
      <div style={gridStyle}>
        {/* Card 1 — Assistent dokumentation (clickable) */}
        <Link to="/aice/assistenter" style={{ textDecoration: 'none' }}>
          <div
            style={{
              ...cardStyle,
              ...(hoveredActive ? cardHoverStyle : {}),
              cursor: 'pointer',
            }}
            onMouseEnter={() => setHoveredActive(true)}
            onMouseLeave={() => setHoveredActive(false)}
          >
            <TbRobot style={iconStyle} />
            <span style={labelStyle}>Assistent dokumentation</span>
          </div>
        </Link>

        {/* Cards 2–6 — placeholder, non-clickable */}
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} style={cardDisabledStyle}>
            <MdOutlineHourglassEmpty style={iconDisabledStyle} />
            <span style={labelDisabledStyle}>Placeholder</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AICEInternal;

const pageStyle = {
  minHeight: '70vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2rem',
};

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '1.5rem',
  width: '100%',
  maxWidth: 800,
};

const cardStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.75rem',
  padding: '2rem 1rem',
  border: `2px solid ${RED}`,
  borderRadius: '16px',
  background: '#fff',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
};

const cardHoverStyle = {
  transform: 'translateY(-6px)',
  boxShadow: '0 20px 40px rgba(192, 54, 38, 0.25)',
};

const iconStyle = {
  fontSize: '2.5rem',
  color: RED,
};

const labelStyle = {
  fontWeight: 700,
  fontSize: '1rem',
  color: '#2A0D05',
  textAlign: 'center',
};

const cardDisabledStyle = {
  ...cardStyle,
  opacity: 0.35,
  filter: 'grayscale(1)',
  cursor: 'not-allowed',
  border: '2px solid #aaa',
};

const iconDisabledStyle = {
  fontSize: '2.5rem',
  color: '#888',
};

const labelDisabledStyle = {
  fontWeight: 700,
  fontSize: '1rem',
  color: '#888',
};
